import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import { CartContext } from '@/store/cart'
import { iconsPath } from '@/config/globals'
import { formatCurrency } from '@/utils/format'
import { disableExtendPlanSingleButton } from '@/utils/extend'

import styles from './styles.module.scss'

const Extend = ({ item, setIsExtendModalVisible, isMattress }) => {
    const { addWarrantyToItem, removeItemFromCart } = useContext(CartContext)
    const extendId = `extend-offer-${item.id}`

    useEffect(() => {
        if (window.Extend && !item.warranty && isMattress) {
            window.Extend.buttons.renderSimpleOffer(`#${extendId}`, {
                referenceId: item.sku,
                theme: {
                    primaryColor: '#000000'
                },
                onAddToCart: async (result) => {
                    if (result.plan && result.product) {
                        const warrantyDetails = {
                            offerPlanId: result.plan.offerPlanId,
                            planId: result.plan.planId,
                            price: result.plan.price,
                            term: result.plan.term,
                            title: result.plan.title,
                            product: item.sku
                        }
                        await addWarrantyToItem(warrantyDetails, item, extendId)
                    }
                }
            })
        }
    }, [!item.warranty, item.id, isMattress])

    const showExtendModal = () => setIsExtendModalVisible(true)
    const removeWarranty = async () => {
        await removeItemFromCart(item, 'extend')
    }

    /**
    * Extend modal cannot be accesed from React because is inserted into the DOM by the ExtendSDK
    * when the user clicks the "Add accident protection" button.
    */
    useEffect(() => {
        document.body.addEventListener('DOMNodeInserted', disableExtendPlanSingleButton)

        return () => {
            document.body.removeEventListener('DOMNodeInserted', disableExtendPlanSingleButton)
        }
    }, [])

    return (
        <>
            {!item.warranty && isMattress &&
                <>
                    <div>
                        {<div id={`${extendId}`} data-selector='cartItem_extend' data-quantity={item.quantity}></div>}
                    </div>
                    <div className='u-flexDisplay item__extendCover'>
                        <img src={`${iconsPath}/extend/icon-extend.svg`} alt="extend" />
                        <button onClick={showExtendModal} className={styles.extendLink}>
                            What's covered?
                        </button>
                    </div>
                </>
            }
            {item.warranty && 
                <div className={styles.warrantyRow}>
                    <div className="warranty-name">
                        <a className={styles.warrantyLogos} onClick={removeWarranty}>
                            <img src={`${iconsPath}/extend/checked-checkbox.svg`} alt="check" />
                            <img src={`${iconsPath}/extend/icon-extend.svg`} alt="extend" className={styles.extendLogo} />
                        </a>
                        <span className={styles.extendYears} >10-Year Protection Plan {item.quantity > 1 && ` x ${item.quantity}`}</span>
                    </div>
                    <div className={styles.price}>
                        <span>{formatCurrency(item.warranty.price * item.warranty.quantity / 100, 2)}</span>
                    </div>
                </div>
            }
        </>
    )
}

Extend.propTypes = {
    item: PropTypes.any.isRequired,
    setIsExtendModalVisible: PropTypes.PropTypes.func.isRequired,
    isMattress: PropTypes.bool.isRequired,
}

export default Extend
